module.exports = __webpack_public_path__ + "media/images/noticia01-1c3b4e23eb90e9f86870f8c3caa3aa8c.jpg";